import Swiper from "swiper11";
import { Thumbs } from "swiper11/modules";
import { createdThumbs, resetImgSize, createWaveClipPath } from "../utils/utils";
import gsap from "gsap";

const productAndService = () => {
  const pageMarker = $("._PandS_");
  if (!pageMarker.length) return;
  createWaveClipPath<string>(
    "M0.000,0.000 C1.000,0.000 130.802,50.809 270.000,78.000 C409.198,105.191 492.652,115.000 573.000,119.1000 C653.348,124.1000 810.285,127.449 942.000,112.1000 C1077.291,97.530 1159.341,72.992 1369.1000,61.000 C1580.659,49.008 1620.170,56.562 1722.1000,62.1000 C1825.830,69.438 1910.950,90.046 {$w},92.000 C{$w},104.680 {$w},124.1000 {$w},124.1000 L{$w},{$h} L0.000,{$h} L0.000,0.000 Z",
    { target: pageMarker.find(".main-content") }
  );
  new Swiper(pageMarker.find(".pands-difference .difference_main__right .swiper-box .swiper")[0], {
    modules: [Thumbs],
    loop: true,
    slidesPerView: 1,
    speed: 850,
    spaceBetween: 30,
    watchSlidesProgress: true,
    on: {
      beforeInit: (swiper) => {
        createdThumbs(swiper, "._PandS_ .difference_main__left .swiper", {
          cloneTarget: "header .title",
          swiperOptions: {
            slidesPerView: 3,
            direction: "vertical",
            centeredSlides: true,
            spaceBetween: 80,
            centeredSlidesBounds: true,
            on: {
              beforeInit: (swiper) => {
                const rootFontSize = Number($("html").css("font-size").replace("px", ""));
                const res = 8 * rootFontSize;
                swiper.params.spaceBetween = res;
                swiper.update();
              },
              init: (swiper) => {
                const H = $(swiper.el).outerHeight()!;
                const pointNum = Math.ceil(H / 20);
                const list = document.createDocumentFragment();
                for (let i = 0; i < pointNum; i++) {
                  const isCenter = Math.ceil(pointNum / 2);
                  const p = $(
                    `<div class='p ${(() => {
                      if (i + 1 === isCenter) {
                        return "center";
                      } else {
                        return "";
                      }
                    })()}'></div>`
                  )[0];
                  list.appendChild(p);
                }
                $(swiper.el).siblings(".point-wrap").children(".list").append(list);
              },
            },
          },
        });
        const List = $(swiper.el).find(".swiper-slide");
        const imgWrap = $("._PandS_ .difference_main__right .cover-box");
        const imgList = document.createDocumentFragment();
        List.each((i, item) => {
          const img = $(
            `<img class="img ${(() => {
              return i === 0 ? "active" : " ";
            })()}" src=${$(item).attr("data-img")} />`
          )[0];
          imgList.appendChild(img);
        });
        imgWrap.append(imgList);
      },
      slidePrevTransitionStart: (swiper) => {
        const POINT = $(".pands-difference .pands-difference_main .difference_main__left .point-wrap .point")[0];
        const POINT_HEIGHT = $(POINT).outerHeight()!;
        const container_Height = $(".pands-difference .pands-difference_main .difference_main__left .swiper-box").outerHeight()!;
        const realThumbs = $(swiper.thumbs.swiper.slides[swiper.realIndex]);
        if (realThumbs.hasClass("swiper-slide-active")) {
          gsap.to(POINT, {
            y: container_Height / 2 - POINT_HEIGHT,
            top: 0,
          });
        } else if (swiper.realIndex + 1 === swiper.thumbs.swiper.slides.length) {
          gsap.to(POINT, {
            y: 0,
            top: "100%",
          });
        } else {
          gsap.to(POINT, {
            y: 0,
            top: 0,
          });
        }
      },
      slideNextTransitionStart: (swiper) => {
        const POINT = $(".pands-difference .pands-difference_main .difference_main__left .point-wrap .point")[0];
        const POINT_HEIGHT = $(POINT).outerHeight()!;
        const container_Height = $(".pands-difference .pands-difference_main .difference_main__left .swiper-box").outerHeight()!;

        const realThumbs = $(swiper.thumbs.swiper.slides[swiper.realIndex]);
        if (realThumbs.hasClass("swiper-slide-active")) {
          gsap.to(POINT, {
            y: container_Height / 2 - POINT_HEIGHT,
            top: 0,
          });
        } else if (swiper.realIndex - 1 < 0) {
          gsap.to(POINT, {
            y: 0,
            top: 0,
          });
        } else {
          gsap.to(POINT, {
            y: 0,
            top: "100%",
          });
        }
      },
      slideChangeTransitionStart: (swiper) => {
        $("._PandS_ .pands-difference .difference_main__right .cover-box .img").eq(swiper.realIndex).addClass("active").siblings().removeClass("active");
      },
    },
  });
  new Swiper(pageMarker.find(".pands-case .swiper-box .swiper")[0], {
    loop: true,
    speed: 850,
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints:{
      621:{
        slidesPerView: 3,
    spaceBetween: 60,
      }
    }
  });
  resetImgSize({
    nodeList: pageMarker.find(".pands-planning .list > li article .img-box .img"),
    setImg: false,
    setBox: true,
  });
};

export default productAndService;
